var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApache(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17611 17611",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11316.5,83.75c-276.25,162.917 -735,624.583 -1282.92,1293.33l503.333,950c353.333,-505.416 712.083,-960 1074.17,-1348.33c27.916,-30.833 42.5,-45.417 42.5,-45.417c-14.167,15 -28.334,30.417 -42.5,45.417c-117.084,129.167 -472.5,543.75 -1008.75,1367.08c516.25,-25.833 1309.58,-131.25 1956.67,-242.083c192.5,-1078.33 -188.75,-1572.08 -188.75,-1572.08c0,-0 -484.583,-784.167 -1053.75,-447.917Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10464.4,5502.92c3.75,-0.834 7.5,-1.25 11.25,-2.084l-72.5,7.917c-4.583,2.083 -8.333,4.167 -12.917,5.833c25,-3.75 49.584,-7.916 74.167,-11.666Z",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9950.62,7204.58c-41.25,9.167 -83.333,16.25 -125.833,22.5c42.5,-6.25 84.583,-13.75 125.833,-22.5Z",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6458.96,11021.7c5.417,-14.167 10.834,-28.334 15.834,-42.5c110.833,-292.5 220.416,-576.667 329.166,-853.75c122.084,-310.834 242.5,-611.667 361.667,-903.334c125.417,-307.5 249.167,-604.583 371.25,-891.666c127.917,-301.25 254.167,-591.25 377.917,-870.417c100.833,-227.083 200,-447.083 297.916,-660c32.5,-70.833 65,-141.25 97.5,-210.833c64.167,-137.917 127.917,-273.334 190.417,-405.417c57.917,-122.083 115.417,-241.25 172.5,-358.333c18.75,-39.167 37.917,-77.5 56.667,-116.25c2.916,-6.25 6.25,-12.5 9.166,-18.75l-61.666,6.666l-49.167,-96.666c-4.583,9.583 -9.583,18.75 -14.583,28.333c-88.334,175.417 -175.834,352.5 -262.5,531.25c-50,103.333 -100,207.083 -149.584,311.25c-137.5,288.75 -272.916,580 -405.833,873.333c-134.583,296.25 -266.25,594.167 -395.417,892.5c-127.083,292.917 -251.25,586.25 -373.333,878.75c-121.667,292.084 -240.417,583.334 -356.667,872.5c-121.25,302.084 -239.166,601.25 -353.333,897.084c-25.833,66.666 -51.667,133.333 -77.083,200c-91.667,238.75 -180.834,474.166 -267.917,706.666l77.5,152.917l69.167,-7.5c2.5,-7.083 5,-14.167 7.5,-20.833c112.083,-306.25 222.916,-604.584 332.916,-895Z",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9792.71,7232.08c0.417,0 0.417,-0.416 0.834,-0.416c-0,-0 -0.417,-0 -0.834,0.416Z",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9626.04,8061.67c-64.167,11.666 -130.417,22.916 -198.334,34.583c-0.416,0 -0.833,0.417 -1.25,0.417c34.167,-5 67.917,-10 101.25,-15.834c33.334,-5.833 65.834,-12.083 98.334,-19.166Z",
    style: {
      fill: "#be202e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9626.04,8061.67c-64.167,11.666 -130.417,22.916 -198.334,34.583c-0.416,0 -0.833,0.417 -1.25,0.417c34.167,-5 67.917,-10 101.25,-15.834c33.334,-5.833 65.834,-12.083 98.334,-19.166Z",
    style: {
      fill: "#be202e",
      fillOpacity: 0.35,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9794.38,7231.25c0,0 -0.417,0 -0.417,0.417c-0.416,-0 -0.416,0.416 -0.833,0.416c10.833,-1.25 21.25,-3.333 31.667,-4.583c42.916,-6.25 85,-13.75 125.833,-22.5c-51.25,8.333 -103.333,17.5 -156.25,26.25Z",
    style: {
      fill: "#be202e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9794.38,7231.25c0,0 -0.417,0 -0.417,0.417c-0.416,-0 -0.416,0.416 -0.833,0.416c10.833,-1.25 21.25,-3.333 31.667,-4.583c42.916,-6.25 85,-13.75 125.833,-22.5c-51.25,8.333 -103.333,17.5 -156.25,26.25Z",
    style: {
      fill: "#be202e",
      fillOpacity: 0.35,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9053.12,4781.67c152.917,-285.834 307.917,-565.417 464.583,-837.5c162.5,-282.5 327.084,-556.667 493.334,-820.834c9.583,-15.416 19.583,-31.25 29.166,-47.083c164.167,-260 330,-510 497.084,-749.167l-503.334,-950c-37.916,46.25 -75.833,93.334 -114.583,141.25c-145,180.834 -295.833,375.417 -450.417,581.667c-174.166,232.5 -353.333,480.833 -535.416,741.25c-167.917,240.833 -338.334,492.917 -508.75,753.75c-145,222.083 -290.834,450.833 -435.417,685.417c-5.417,8.75 -10.833,17.5 -16.25,26.25l655,1293.75c140,-277.084 281.667,-550.417 425,-818.75Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6069.79,12071.2c-86.667,238.333 -173.75,480.833 -261.25,728.75c-1.25,3.75 -2.5,7.083 -3.75,10.833c-12.5,35 -24.584,70 -37.084,105c-58.75,167.084 -110,317.5 -227.083,659.584c192.917,87.916 347.917,319.583 494.583,582.5c-15.416,-272.084 -128.333,-527.917 -342.083,-725.834c951.25,42.917 1770.83,-197.5 2194.58,-892.916c37.917,-62.084 72.5,-127.084 103.75,-196.667c-192.5,244.167 -431.25,347.917 -880.833,322.5c-0.833,0.417 -2.083,0.833 -2.917,1.25c0.834,-0.417 2.084,-0.833 2.917,-1.25c661.667,-296.25 993.75,-580.417 1287.08,-1051.67c69.584,-111.666 137.084,-233.75 206.25,-369.166c-578.75,594.166 -1249.17,763.333 -1955.42,635l-529.584,57.916c-16.666,44.584 -32.916,89.167 -49.166,134.167Z",
    style: {
      fill: "url(#_Linear3)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6316.88,10885c114.583,-295.833 232.5,-595 353.333,-897.083c115.834,-289.167 235,-580 356.667,-872.5c121.667,-292.5 246.25,-585.417 373.333,-878.75c129.167,-298.334 261.25,-596.25 395.417,-892.5c132.917,-292.917 268.333,-584.584 405.833,-873.334c49.584,-104.166 99.584,-207.916 149.584,-311.25c86.666,-178.75 174.166,-355.833 262.5,-531.25c4.583,-9.583 9.583,-18.75 14.583,-28.333l-655,-1293.75c-10.833,17.5 -21.25,35 -32.083,52.5c-152.5,249.167 -304.584,504.167 -453.75,764.583c-150.834,262.917 -298.75,530.834 -443.334,802.5c-122.083,229.167 -241.25,460.417 -357.083,693.75c-23.333,47.5 -46.25,94.167 -69.167,141.25c-142.916,293.75 -271.666,577.5 -388.333,850.417c-132.083,309.167 -248.333,604.583 -350,884.583c-67.083,184.167 -127.917,362.084 -183.75,532.917c-45.833,145.833 -89.583,292.083 -130.833,437.5c-97.917,342.917 -182.084,685 -251.25,1025.83l658.333,1299.58c87.083,-232.5 176.25,-467.917 267.917,-706.667c25.416,-66.25 51.25,-133.333 77.083,-200Z",
    style: {
      fill: "url(#_Linear4)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5304.79,10538.3c-82.5,415.834 -141.25,830 -170.834,1241.67c-0.833,14.583 -2.5,28.75 -3.333,43.333c-205.417,-329.166 -755.417,-650.416 -754.167,-647.5c393.75,570.834 692.5,1137.5 737.084,1693.75c-210.834,43.334 -499.584,-19.166 -833.334,-142.083c347.917,319.583 609.167,407.917 710.834,431.667c-319.584,20 -652.5,239.583 -987.917,492.5c490.417,-200 886.667,-279.167 1170.42,-215c-450,1274.17 -901.25,2680.83 -1352.5,4174.17c138.333,-40.833 220.833,-133.75 267.083,-259.583c80.417,-270.417 614.167,-2044.58 1450.42,-4376.67c23.75,-66.25 47.916,-132.916 72.083,-200c6.667,-18.75 13.75,-37.5 20.417,-55.833c88.333,-244.583 180,-494.167 274.583,-748.75c21.667,-57.917 43.333,-115.833 65,-174.167c0.417,-1.25 0.833,-2.5 1.25,-3.333l-657.5,-1299.17c-2.917,14.584 -6.667,29.584 -9.583,45Z",
    style: {
      fill: "url(#_Linear5)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8729.79,5709.58c-18.75,38.334 -37.5,77.084 -56.667,116.25c-56.667,117.084 -114.167,236.25 -172.5,358.334c-62.917,132.083 -126.25,267.083 -190.417,405.416c-32.5,69.584 -64.583,139.584 -97.5,210.834c-97.916,212.916 -197.083,432.916 -297.916,660c-123.75,279.166 -250,569.166 -377.917,870.416c-122.083,287.084 -245.833,584.167 -371.25,891.667c-119.167,291.667 -239.583,592.917 -361.667,903.333c-108.75,277.084 -218.333,561.25 -329.166,853.75c-5.417,14.167 -10.834,28.334 -15.834,42.5c-110,290.417 -220.833,588.75 -332.5,894.584c-2.5,7.083 -5,14.166 -7.5,20.833l529.584,-57.917c-10.417,-2.083 -21.25,-3.333 -31.667,-5.416c633.333,-78.75 1475,-552.084 2019.17,-1136.25c250.833,-269.167 478.333,-586.667 688.75,-958.334c156.666,-276.666 303.75,-583.333 443.75,-922.916c122.5,-296.667 240,-617.917 353.333,-966.25c-145.417,76.666 -312.083,132.916 -495.833,172.083c-32.084,6.667 -65,13.333 -98.334,19.167c-33.333,5.833 -67.083,11.25 -101.25,15.833c0.417,-0 0.834,-0.417 1.25,-0.417c590.417,-227.083 962.917,-665.833 1233.75,-1202.92c-155.416,105.833 -407.916,244.583 -710.416,311.25c-41.25,9.166 -83.334,16.25 -125.834,22.5c-10.833,1.666 -21.25,3.333 -31.666,4.583c0.416,-0 0.416,-0.417 0.833,-0.417c0,0 0.417,0 0.417,-0.416c205,-85.834 377.916,-181.667 527.916,-295c32.084,-24.167 63.334,-49.167 93.334,-75.417c45.833,-39.583 89.166,-81.25 130.833,-125c26.667,-27.917 52.5,-56.667 77.5,-86.667c58.75,-70 113.75,-145.416 165.417,-227.5c15.833,-25 31.25,-50.416 46.666,-76.666c19.584,-37.917 38.334,-75 56.667,-111.667c82.5,-165.833 148.333,-313.75 200.833,-443.75c26.25,-65 49.167,-125 68.75,-180.833c7.917,-22.084 15.417,-43.75 22.5,-64.584c20.834,-62.5 37.917,-117.916 51.25,-166.666c20,-72.917 32.084,-130.834 38.75,-172.917c-20,15.833 -42.916,31.667 -68.75,47.083c-178.333,106.667 -484.166,203.334 -730.833,248.75l486.25,-53.333l-486.25,53.333c-3.75,0.834 -7.5,1.25 -11.25,2.084c-24.583,4.166 -49.583,7.916 -74.583,12.083c4.583,-2.083 8.333,-4.167 12.916,-5.833l-1663.75,182.5c-2.916,5.833 -5.833,11.666 -9.166,17.916Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10602.7,2346.25c-147.916,227.083 -309.583,485 -483.333,777.083c-9.167,15 -18.333,30.834 -27.5,46.25c-150,252.917 -309.583,530.417 -477.083,834.584c-145,262.5 -295.834,544.166 -452.5,847.083c-136.667,263.75 -277.917,543.75 -422.917,840l1663.75,-182.5c484.583,-222.917 701.25,-424.583 911.667,-716.25c55.833,-80.417 112.083,-164.583 167.916,-251.667c170.834,-266.666 338.334,-560.416 488.334,-852.5c144.583,-282.083 272.083,-561.666 370,-813.75c62.083,-160.416 112.083,-309.583 146.666,-440.416c30.417,-115.417 54.167,-225 72.5,-329.584c-647.916,110.417 -1441.25,216.25 -1957.5,241.667Z",
    style: {
      fill: "url(#_Linear7)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9527.71,8080.83c-33.333,5.834 -67.083,11.25 -101.25,15.834c34.167,-4.584 67.917,-10 101.25,-15.834Z",
    style: {
      fill: "#be202e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9527.71,8080.83c-33.333,5.834 -67.083,11.25 -101.25,15.834c34.167,-4.584 67.917,-10 101.25,-15.834Z",
    style: {
      fill: "#be202e",
      fillOpacity: 0.35,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9527.71,8080.83c-33.333,5.834 -67.083,11.25 -101.25,15.834c34.167,-4.584 67.917,-10 101.25,-15.834Z",
    style: {
      fill: "url(#_Linear8)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9792.71,7232.08c10.834,-1.25 21.25,-3.333 31.667,-4.583c-10.417,1.25 -20.833,2.917 -31.667,4.583Z",
    style: {
      fill: "#be202e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9792.71,7232.08c10.834,-1.25 21.25,-3.333 31.667,-4.583c-10.417,1.25 -20.833,2.917 -31.667,4.583Z",
    style: {
      fill: "#be202e",
      fillOpacity: 0.35,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9792.71,7232.08c10.834,-1.25 21.25,-3.333 31.667,-4.583c-10.417,1.25 -20.833,2.917 -31.667,4.583Z",
    style: {
      fill: "url(#_Linear9)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9793.96,7231.67c0,-0 0.417,-0 0.417,-0.417c0,0 -0.417,0 -0.417,0.417Z",
    style: {
      fill: "#be202e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9793.96,7231.67c0,-0 0.417,-0 0.417,-0.417c0,0 -0.417,0 -0.417,0.417Z",
    style: {
      fill: "#be202e",
      fillOpacity: 0.35,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9793.96,7231.67c0,-0 0.417,-0 0.417,-0.417c0,0 -0.417,0 -0.417,0.417Z",
    style: {
      fill: "url(#_Linear10)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13065.6,1612.5l0,48.75l114.167,0l-0,322.5l52.916,0l0,-322.5l115,0l0,-48.75l-282.083,0Zm659.583,0l-127.5,259.167l-128.333,-259.167l-63.75,0l0,371.25l48.75,0l0,-294.583l126.25,255.416l33.75,0l126.25,-255.416l0,294.583l48.75,0l0,-371.25l-64.167,0Z",
    style: {
      fill: "#6d6e71",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3687.25,-1025.17,1025.17,3687.25,10460.2,1493.45)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f69923",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#f79a23",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#e97826",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e97826",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7499.62,-16083.6,16083.6,7499.62,2389.41,18042.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#c92037",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#cd2335",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e97826",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4469.05,-9584.23,9584.23,4469.05,4907.87,16852.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282662",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#662e8d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#9f2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#cd2032",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#cd2032",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7499.62,-16083.5,16083.5,7499.62,2660.76,17069)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#c92037",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#cd2335",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e97826",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3941.28,-8452.39,8452.39,3941.28,3425.32,15997.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282662",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#662e8d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#9f2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#cd2032",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#cd2032",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7499.62,-16083.5,16083.5,7499.62,4325.35,17845.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#c92037",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#cd2335",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e97826",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7499.62,-16083.5,16083.5,7499.62,3777.47,18804.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#c92037",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#cd2335",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e97826",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7499.62,-16083.5,16083.5,7499.62,4820.43,18076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#c92037",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#cd2335",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e97826",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7499.62,-16083.5,16083.5,7499.62,4763.78,18049.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#c92037",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#cd2335",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e97826",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1657.66,-3554.99,3554.99,1657.66,8965.6,9008.77)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#9e2064",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#c92037",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#cd2335",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e97826",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApache);
export default __webpack_public_path__ + "static/media/apache.d2ee5341d7f73061b11a7df82d6d1b51.svg";
export { ForwardRef as ReactComponent };